import React from 'react';
import ParticipantDidSomething from '../common/ParticipantDidSomething';

import { useText } from 'common/hooks';
import { ICON } from 'resources/constants';

type Props = {
  readonly profileKey: string;
  readonly joinedDatetime: number;
};

export default function ParticipantJoined({
  joinedDatetime,
  profileKey,
}: Props): React.ReactElement {
  const t = useText();

  return (
    <ParticipantDidSomething
      profileKey={profileKey}
      icon={ICON.groupAdd}
      datetime={joinedDatetime}
    >
      {t('challenge.latest_events.FeC003.participating_in_your_team')}
    </ParticipantDidSomething>
  );
}
